import {WinPresentationController} from "../WinPresentationController";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {BetWinMode} from "../../../core/config/BetWinMode";
import {RockBottom} from "../../RockBottom";
import {RockBottomGameConfig} from "../../RockBottomGameConfig";
import {IBetWayWinData} from "../../server/data/IRockBottomData";
import {RockBottomSymbolState} from "../../symbol/RockBottomSymbolConfig";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";
import {RockBottomSymbol} from "../../symbol/RockBottomSymbol";

export class NoWinSymbolsController extends WinPresentationController {
    private _belowStakeWinRestriction: boolean;

    constructor() {
        super("NoWinSymbolsController", false);
    }

    protected hasWin(): boolean {
        this._belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowPlayedBetValue();
        return (RockBottom.model.parsedGameData.betWins?.length > 0 || RockBottom.model.parsedGameData.freespinTriggeredThisSpin) && !this._belowStakeWinRestriction;
    }

    protected reelSymbolsLength(index: number): number {
        let symbols: number[] = RockBottomGameConfig.SYMS_PER_REEL;
        return symbols[index];
    }

    protected async createWinAnimation(): Promise<void> {
        const symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(RockBottomGameConfig.REELS_NUM, (idx: number) => {
            return ArrayHelper.initArrayWithValues<boolean>(this.reelSymbolsLength(idx), () => false)
        });
        const gameData = RockBottom.model.parsedGameData;
        switch (RockBottomGameConfig.BET_WIN_MODE) {
            case BetWinMode.BET_WAY:
                (<IBetWayWinData[]>gameData.betWins).forEach(winWay => {
                    winWay.reelWinPositions.forEach((reelWin, reelId) => {
                        reelWin.forEach((symWin, symId) => {
                            if (symWin) {
                                symbolWinStates[reelId][symId] = true;
                            }
                        });
                    });
                });
                break;
            default:
                debugger;
                throw new Error(`NoWinSymbolsController, wrong BetWinMode in config.`);
        }
        if (gameData.freespinTriggeredThisSpin) {
            gameData.scatterPositions?.forEach((symId, reelId) => {
                if (symId > -1) {
                    symbolWinStates[reelId][symId] = true;
                }
            });
        }

        const promises: Promise<any>[] = [];
        symbolWinStates.forEach((reelWin, reelId) => {
            reelWin.forEach((symWin, symId) => {
                if (!symWin) {
                    let sym: RockBottomSymbol = RockBottom.reels[reelId].getSymbol(symId);
                    promises.push(Promise.resolve(
                        sym.getStateAnimation(RockBottomSymbolState.NO_WIN).add(() => {
                            sym.getTint();
                        })
                    ));
                }
            });
        });

        await Promise.all(promises);
    }
}